import { gql } from 'apollo-client-ppc';

export const fetchAvailablePromotionsForPartnerProductQuery = gql`
  query fetchAvailablePromotionsForPartnerProduct(
    $id: ID!
    $filterPromotions: AvailablePromotionRequest
    $includeExperimentalProducts: Boolean
  ) {
    nativeCatalogItem: partnerNativeCatalogItem(id: $id, includeExperimentalProducts: $includeExperimentalProducts) {
      availablePromotions(filterPromotions: $filterPromotions) {
        promotionId
        title
        status
        cycleInterval
        pricingType
        type
      }
    }
  }
`;
